import axios from 'axios';
import {
  stringify,
} from 'qs';

import {
  keycloakAuthenticationHandler,
} from '@/authentication.ts';
import config from '@/config/config.js';

export const API_URL = config.VITE_APP_API_URL as string;

const portalApi = axios.create({
  withCredentials: true,
  baseURL: `${API_URL}/api/v1`,
  paramsSerializer: (params) => stringify(params, {
    arrayFormat: 'repeat',
  }),
});
keycloakAuthenticationHandler.secureAxiosClient(portalApi);

export {
  portalApi,
};
